export default "__VITE_ASSET__Ctr4ohBZ__"